module.exports = __webpack_public_path__ + "img/doc-context-similarity-min.620fa1dd.jpg";